/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMealSchedules } from 'app/entities/meal-schedule/meal-schedule.reducer';
import { getEntities as getRecipes } from 'app/entities/recipe/recipe.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getNutritionPlans } from 'app/entities/nutrition-plan/nutrition-plan.reducer';
import { createEntity, getEntity, reset, updateEntity } from './meal-advise.reducer';

export const MealAdviseUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const mealSchedules = useAppSelector(state => state.mealSchedule.entities);
  const recipes = useAppSelector(state => state.recipe.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nutritionPlans = useAppSelector(state => state.nutritionPlan.entities);
  const mealAdviseEntity = useAppSelector(state => state.mealAdvise.entity);
  const loading = useAppSelector(state => state.mealAdvise.loading);
  const updating = useAppSelector(state => state.mealAdvise.updating);
  const updateSuccess = useAppSelector(state => state.mealAdvise.updateSuccess);

  const handleClose = () => {
    navigate(`/meal-advise${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMealSchedules({}));
    dispatch(getRecipes({}));
    dispatch(getDoctors({}));
    dispatch(getNutritionPlans({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...mealAdviseEntity,
      ...values,
      mealDetailsSchedule: mealSchedules.find(it => it.id.toString() === values.mealDetailsSchedule?.toString()),
      recipeMealDetails: recipes.find(it => it.id.toString() === values.recipeMealDetails?.toString()),
      advisedBy: doctors.find(it => it.id.toString() === values.advisedBy?.toString()),
      nutritionPlan: nutritionPlans.find(it => it.id.toString() === values.nutritionPlan?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...mealAdviseEntity,
          mealDetailsSchedule: mealAdviseEntity?.mealDetailsSchedule?.id,
          recipeMealDetails: mealAdviseEntity?.recipeMealDetails?.id,
          advisedBy: mealAdviseEntity?.advisedBy?.id,
          nutritionPlan: mealAdviseEntity?.nutritionPlan?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mealAdvise.home.createOrEditLabel" data-cy="MealAdviseCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mealAdvise.home.createOrEditLabel">Create or edit a MealAdvise</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="meal-advise-id"
                  label={translate('tinyMedicRestApp.mealAdvise.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mealAdvise.active')}
                id="meal-advise-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealAdvise.timestampentry')}
                id="meal-advise-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealAdvise.lastupdated')}
                id="meal-advise-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealAdvise.cursor')}
                id="meal-advise-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealAdvise.microSec')}
                id="meal-advise-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="meal-advise-mealDetailsSchedule"
                name="mealDetailsSchedule"
                data-cy="mealDetailsSchedule"
                label={translate('tinyMedicRestApp.mealAdvise.mealDetailsSchedule')}
                type="select"
                required
              >
                <option value="" key="0" />
                {mealSchedules
                  ? mealSchedules.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-advise-recipeMealDetails"
                name="recipeMealDetails"
                data-cy="recipeMealDetails"
                label={translate('tinyMedicRestApp.mealAdvise.recipeMealDetails')}
                type="select"
                required
              >
                <option value="" key="0" />
                {recipes
                  ? recipes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-advise-advisedBy"
                name="advisedBy"
                data-cy="advisedBy"
                label={translate('tinyMedicRestApp.mealAdvise.advisedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-advise-nutritionPlan"
                name="nutritionPlan"
                data-cy="nutritionPlan"
                label={translate('tinyMedicRestApp.mealAdvise.nutritionPlan')}
                type="select"
              >
                <option value="" key="0" />
                {nutritionPlans
                  ? nutritionPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/meal-advise" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MealAdviseUpdate;
